module.exports = __webpack_public_path__ + "img/webworthy-full.1d333427.jpg";